// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import ChooseCardChallengeLayer from "./ChooseCardChallengeLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ChooseCardChallengeItem extends BaseComponent {

	@property({ type: cc.Button, displayName:'' })
	btnSelect: cc.Button = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSelect: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	spr_mj_big: cc.Node = null;

	@property({ type: sp.Skeleton, displayName:'' })
	sc_Mahjiong: sp.Skeleton = null;

	// @property({ type: BaseStateSprite, displayName:'' })
	// sprBg: BaseStateSprite = null;
    @property({ type: cc.Node, displayName:'' })
	nodeBlack: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnClick: cc.Node = null;
    

    private curIdx: number = 0;
    private _parent: ChooseCardChallengeLayer = null;
    private cardData: number = null;

    private bselect = false;

    private bCanUse = true;
    private bEnable = true;
    // onLoad () {}

    start () {
        this.resetData();
        this.initUI();
    }

    resetData() {
        this.sc_Mahjiong.node.active = false;
        this.btnClick.active = true;
        this.nodeBlack.active = false;
        this.nodeSelect.active = false;

        this.setSelect(this.bselect);
    }

    setData(
        cardData: number
        , _parent: ChooseCardChallengeLayer
        , curIdx: number
    ) {
        this.curIdx = curIdx;
        this._parent = _parent;
        this.cardData = cardData;
    }

    initUI() {
      
    }

    setValid(enable: boolean) {
        this.bEnable = enable;
        this.btnClick.active = false;
        this.nodeBlack.active = false;
        this.btnSelect.interactable = enable;
        
        if (enable) {
            this.btnClick.active = true;
        } else {
            this.nodeSelect.active = false;
            this.nodeBlack.active = true;
        }
    }

    setClickState(enable: boolean) {
        this.btnClick.active = enable;
    }

    setCanUse(bCanUse: boolean) {
        this.bCanUse = bCanUse;
    }

    setSelect(bselect: boolean) {
        if (!this.bEnable) {
            return;
        }
        this.bselect = bselect;
        this.btnClick.active = !bselect;
        this.nodeSelect.active = bselect;
    }
    
    isCanUse() {
        return this.btnClick.active;
    }

    getCardData() {
        return this.cardData;
    }

    async onClickEnd() {
        if (!this.bCanUse) {
            return;
        }
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this._parent.selectCard(this.curIdx);
    }

    async onClickSelect() {
        if (!this.bCanUse) {
            return;
        }
        O1HD.getManagers().soundMgr.playSound("anNiu");
        await this.startRotateAni();
        if (!this.node || !cc.isValid(this.node)) {
            return;
        }
        this._parent.showRet(this.cardData, this.curIdx);
    }

    async startRotateAni() {
        return  new Promise<void>((resolve=> {
            const aniName = ['a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9']
            let idx = this.cardData - 12;
            
            this.spr_mj_big.active = false;
            this.sc_Mahjiong.node.active = true;
            this.sc_Mahjiong.setSkin(aniName[idx]);
            this.sc_Mahjiong.setAnimation(0, 'Right', false);
            this.sc_Mahjiong.setCompleteListener(()=> {
                resolve();
            });
        }))
    }

    showBgState(bfill: boolean) {
        // this.sprBg.setFill(bfill);
    }

    // update (dt) {}
}
